export const RESEARCH_UPDATE_CONNECT_DOMAINS = 'research/task/connectDomains';
export const RESEARCH_UPDATE_SITE_CONNECT_DOMAINS =
  'research/site/connectDomains';
